import React from 'react';
import { motion } from 'framer-motion';
type InlineCTAProps = {
  text: string;
  linkText: string;
  href?: string;
  variant?: 'soft' | 'strong';
};
export function InlineCTA({
  text,
  linkText,
  href = 'https://shopavenso.com/products/luise-haarol',
  variant = 'soft'
}: InlineCTAProps) {
  if (variant === 'strong') {
    return <motion.div initial={{
      opacity: 0,
      y: 12
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-editorial mx-auto px-4 py-10" data-id="element-155">
        <div className="bg-cream-dark border border-charcoal/10 rounded-lg px-6 py-8 md:px-10 md:py-10 text-center" data-id="element-156">
          <p className="text-lg md:text-xl text-charcoal/90 font-heading mb-5" data-id="element-157">
            {text}
          </p>
          <a href={href} target="_blank" rel="noopener noreferrer" className="inline-block bg-accent hover:bg-accent-light text-charcoal font-ui font-semibold uppercase tracking-wider py-3 px-8 rounded-sm transition-colors duration-300 text-sm" data-id="element-158">
            {linkText}
          </a>
        </div>
      </motion.div>;
  }
  return <motion.div initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="max-w-editorial mx-auto px-4 py-6" data-id="element-159">
      <div className="border-l-2 border-accent/40 pl-5 py-2" data-id="element-160">
        <p className="text-charcoal/70 italic text-base md:text-lg" style={{
        fontFamily: 'Georgia, serif'
      }} data-id="element-161">
          {text}{' '}
          <a href={href} target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent-light font-semibold not-italic transition-colors duration-200" data-id="element-162">
            {linkText} →
          </a>
        </p>
      </div>
    </motion.div>;
}